import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthgaurdService } from './authgaurd.service';

import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { BillingComponent } from './pages/billing/billing.component';
import { OrdersComponent } from './pages/orders/orders.component';
import { InvoiceComponent } from './pages/invoice/invoice.component';
import { CustomersComponent } from './pages/customers/customers.component';
import { BankComponent } from './pages/bank/bank.component';
import { ProductsComponent } from './pages/products/products.component';
import { InvoicePreviewComponent } from './pages/invoice-preview/invoice-preview.component';
import { ChangeOrderComponent } from './pages/change-order/change-order.component';




const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthgaurdService] },
  { path: 'billing', component: BillingComponent, canActivate: [AuthgaurdService] },
  { path: 'invoice', component: InvoiceComponent, canActivate: [AuthgaurdService] },
  { path: 'customers', component: CustomersComponent, canActivate: [AuthgaurdService] },
  { path: 'bank', component: BankComponent, canActivate: [AuthgaurdService] },
  { path: 'products', component: ProductsComponent, canActivate: [AuthgaurdService] },
  { path: 'orders', component: OrdersComponent, canActivate: [AuthgaurdService] },
  { path: 'change-order', component: ChangeOrderComponent, canActivate: [AuthgaurdService] },
  { path: 'invoice-preview', component: InvoicePreviewComponent, canActivate: [AuthgaurdService] },
  // { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
